import { Victories } from '~/models/victories';
import { Image } from '~/models/image';

export const victoriesService = {
	fetch: async (): Promise<Victories.Model | null> => {
		const params = {
			fields: ['*', 'photo.directus_files_id.*', 'form.*'],
		};

		try {
			const response = await $fetch<
				Omit<Victories.Model, 'photo'> & { photo: { directus_files_id: Image.Model }[] }
			>(Victories.api, {
				method: 'POST',
				body: { params },
			});

			/** Resolve images */
			const images = response.photo.reduce((acc, { directus_files_id }) => {
				acc.push(directus_files_id);
				return acc;
			}, [] as Image.Model[]);

			return { ...response, photo: images };
		} catch (error) {
			console.error('Failed to fetch Victories:', error);

			return null;
		}
	},
};
